(function () {
  var PER_ITEM = 6.99;
  var THRESHOLD = 99;

  function addStyle() {
    if (document.getElementById('atc-ship-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-ship-style';
    s.textContent = [
      '.atc-ship{display:flex;align-items:flex-start;gap:10px;margin:14px 0;padding:11px 14px;',
      'border:1px solid rgba(255,255,255,.18);border-radius:10px;font-size:13px;line-height:1.5;}',
      '.atc-ship__icon{flex:0 0 auto;margin-top:1px;opacity:.85;}',
      '.atc-ship b{font-weight:700;}',
      '.atc-ship__sub{display:block;opacity:.65;font-size:12px;margin-top:2px;}'
    ].join('');
    document.head.appendChild(s);
  }

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return f;
    }
    return null;
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'atc-ship';
    wrap.setAttribute('data-atc-ship', '');
    wrap.innerHTML =
      '<svg class="atc-ship__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M1 3h15v13H1z"></path><path d="M16 8h4l3 3v5h-7V8z"></path>' +
      '<circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
      '<span><b>FREE U.S. shipping on orders over $' + THRESHOLD + '</b>' +
      '<span class="atc-ship__sub">Under $' + THRESHOLD + ', shipping is $' + PER_ITEM.toFixed(2) + ' per item. Delivery 7-15 days.</span></span>';
    return wrap;
  }

  function inject() {
    var form = mainForm();
    if (!form) return;
    if (form.querySelector('[data-atc-ship]')) return;

    addStyle();
    var wrap = build();
    var submit = form.querySelector('[type="submit"]');
    var anchor = submit ? (submit.closest('.product-form-buttons, .product-form__buttons, buy-buttons-component') || submit) : null;

    if (anchor && anchor.parentNode && form.contains(anchor)) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      form.appendChild(wrap);
    }
  }

  function start() {
    inject();
    var mo = new MutationObserver(function () { inject(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();